import { useCallback } from 'react';
import { useControllable } from '../../hooks';
export function useDialogState({
  open: openProp,
  defaultOpen = false,
  onOpenChange
} = {}) {
  const [open, setOpen] = useControllable({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  const show = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);
  const toggle = useCallback(() => setOpen(v => !v), [open]);
  return {
    open,
    show,
    close,
    toggle,
    setOpen
  };
}